import { render } from "./CoachesList.vue?vue&type=template&id=f013a8ba&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=f013a8ba&scoped=true&lang=css"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f013a8ba"]])

export default __exports__